import * as tslib_1 from "tslib";
import { HttpEventType } from '@angular/common/http';
import { OnDestroy, OnInit, } from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { ClientErrorCodes, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { NugetServiceFactory } from '@pages/packages/shared/nuget.util';
import { FileUploadService, ModalService, } from '@services';
import { unsubscribe } from '@utils/object.utils';
import { BehaviorSubject, of, Subject, } from 'rxjs';
import { auditTime, delay, distinctUntilChanged, finalize, map, pairwise, startWith, switchMap, } from 'rxjs/operators';
import { NugetUpgradeModalComponent } from '../nuget-upgrade/nuget-upgrade.modal';
var TRANSITION_SPEED = 250;
var NugetUploadModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetUploadModalComponent, _super);
    function NugetUploadModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.files = [];
        _this.loading$ = new BehaviorSubject(false);
        _this._allowedFileExtensions = ['.nupkg'];
        _this._nugetService = _this._injector.get(NugetServiceFactory(_this.context.additionalData.type));
        _this._modalService = _this._injector.get(ModalService);
        _this._progressSource = new Subject();
        _this._upgradeChecked = false;
        return _this;
    }
    Object.defineProperty(NugetUploadModalComponent.prototype, "fileNames", {
        get: function () {
            return this.files.map(function (file) { return file.name; }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    NugetUploadModalComponent.prototype.ngOnInit = function () {
        // hide progress for fast uploads
        // and show the progress bar for multiple progress states
        this.showProgressBar$ = this._progressSource
            .pipe(startWith(0), map(function (progress) { return !!progress; }), distinctUntilChanged(), pairwise(), switchMap(function (_a) {
            var previous = _a[0], current = _a[1];
            return of(current)
                .pipe(delay(!previous &&
                current ?
                TRANSITION_SPEED :
                0));
        }));
        // update progress according to the progress-bar transition speed
        this.progress$ = this._progressSource
            .pipe(auditTime(TRANSITION_SPEED));
        this._fileUploadService = this._injector.get(FileUploadService);
        this._translateService = this._injector.get(TranslateService);
        this.type = this.context.additionalData.type;
    };
    NugetUploadModalComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._uploadSub);
    };
    NugetUploadModalComponent.prototype.onClear = function () {
        this.files = [];
    };
    NugetUploadModalComponent.prototype.onFileChange = function (files) {
        this.files = files;
    };
    NugetUploadModalComponent.prototype.onSubmit = function () {
        var _this = this;
        var areFilesValid = this.files.some(function (file) { return _this._fileUploadService.isFileItemValid(file, _this._allowedFileExtensions); });
        if (!areFilesValid) {
            this._snack.error(this._translateService.instant(this.type + "_upload_package_modal_file_input_warning") + " (#" + ClientErrorCodes.InvalidFile + ")");
            return;
        }
        this.loading$.next(true);
        this._uploadSub = this._nugetService.uploadPackages(this.files)
            .pipe(finalize(function () {
            _this.loading$.next(false);
            _this._progressSource.next(0);
        }))
            .subscribe(function (ev) {
            if (ev.type === HttpEventType.UploadProgress) {
                _this._progressSource.next(Math.round((ev.loaded * 100) / ev.total));
            }
            if (ev.type === HttpEventType.Response) {
                var body = (ev.body.value)
                    .map(function (response) { return ({
                    key: response.Key,
                    status: response.Status,
                    body: JSON.parse(response.Body),
                }); });
                var success = body.filter(function (response) { return response.status === 200 || response.status === 'OK'; });
                var error_1 = body.filter(function (response) { return response.status !== 200 && response.status !== 'OK'; });
                // success
                if (success && success.length) {
                    _this._dialogRef.close({
                        type: 1 /* Add */,
                    });
                    if (_this._upgradeChecked) {
                        _this._modalService
                            .openModal(NugetUpgradeModalComponent, null, {
                            data: {
                                packages: success.map(function (data) { return ({
                                    id: data.body.Id,
                                    version: data.body.Version,
                                }); }),
                                type: _this.type,
                            },
                        })
                            .afterClosedResult();
                    }
                }
                // we have failed items:
                if (error_1 && error_1.length) {
                    var errorMessage = error_1.map(function (bulkitem) {
                        var packageError = bulkitem.body;
                        return bulkitem.key + ": " + packageError.Message + " (#" + packageError.ErrorCode + ")";
                    }).join('\n');
                    _this._snack.error(errorMessage);
                    // if we successfully uploaded some items, reload the grid
                    if (_this.files.length - error_1.length > 0) {
                        _this.customEvent.emit({
                            type: 2 /* Update */,
                        });
                    }
                    // remove the uploaded files from the form (for resubmitting?)
                    _this.files = _this.files.filter(function (file) { return error_1.find(function (i) { return i.key === file.name; }); });
                }
            }
        });
    };
    NugetUploadModalComponent.prototype.checkUpgradeValue = function (event) {
        this._upgradeChecked = event.checked;
    };
    return NugetUploadModalComponent;
}(UiModalComponent));
export { NugetUploadModalComponent };
